import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchValueFromValueList } from "../../utils/apiUtils";
import { useEffect, useState, useCallback } from "react";
import { useInView } from 'react-intersection-observer'
import SharedTable from "./SharedTable";
import { loadBenefitPlans } from "../../utils/optionLoaderUtils";
import { customStyles } from "../../utils/styleUtils";
import { AsyncPaginate } from "react-select-async-paginate";
import debounce from 'lodash.debounce';
import { queryClient } from "../../App";

const limit = 10
let columns = ['valueName', 'value', 'percentValue', 'variableValueKey'];

const ValueListTable = ({ benefitPlanName, benefitPlanHccId, benefitPlanKey, benefitPlanHistoryFactKey }) => {
    const [searchValue, setSearchValue] = useState('');
    const [decouncedSearchValue, setDecouncedSearchValue] = useState('')
    const [selectedBenefitPlan, setSelectedBenefitPlan] = useState(null)

    const { ref, inView } = useInView()

    useEffect(() => {
        setSelectedBenefitPlan(benefitPlanName ? {
            label: benefitPlanName, value: benefitPlanHccId,
            additional: { benefitPlanName, benefitPlanHccId, benefitPlanKey, benefitPlanHistoryFactKey }
        } : null)
    }, [])

    const queryKey = ['valueList', limit, selectedBenefitPlan, decouncedSearchValue];
    const {
        data,
        error,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetching,
        isFetchingNextPage,
        status,
    } = useInfiniteQuery({
        queryKey,
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {}

            if (decouncedSearchValue) {
                params.valueNamePrefix = decouncedSearchValue
            }

            return await fetchValueFromValueList({
                ...params,
                benefitPlanKey: selectedBenefitPlan.additional?.benefitPlanKey,
                benefitPlanHistoryFactKey: selectedBenefitPlan.additional?.benefitPlanHistoryFactKey,
            })
        },
        select: (data) => {
            //   console.log({ data });
            return { count: data.pages?.[0]?.count, rows: data.pages.map((page) => page.rows).flatMap((x) => x) };
        },
        initialPageParam: 0,
        placeholderData: (previousData) => previousData,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage.rows?.length === limit

            if (!hasMore) return undefined
            return {
                offset: pages.reduce((accum, page) => {
                    return accum + page.rows.length;
                }, 0),
            };
        },
        staleTime: 0,
        enabled: !!selectedBenefitPlan,
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage()
        }
    }, [inView])

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    return (
        <div className={'container '} style={{ padding: '1rem' }}>
            <p style={{ fontSize: '1.2rem', fontWeight: '600' }}>ValueList  ( {data?.count || 0} )</p>
            <p className="sub-title">Benefit Plan Value List</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', paddingRight: '1rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', justifyContent: 'start', width: '100%', padding: '1rem 0rem' }}>
                    {!benefitPlanKey && <AsyncPaginate
                        placeholder={"Select a benefit plan"}
                        className="react-select-container large-input"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}
                        value={selectedBenefitPlan}
                        loadOptions={loadBenefitPlans}
                        onChange={setSelectedBenefitPlan}
                        styles={customStyles}
                        isClearable
                    />}

                    <input
                        style={{ fontSize: '1rem', minWidth: '250px', padding: '1rem', borderRadius: '.4rem', border: '1px solid var(--lighterGrey)', outline: 'none' }}
                        type="text"
                        id={'search'}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />

                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        //   queryClient.invalidateQueries({ queryKey });
                        queryClient.resetQueries({ queryKey });
                        setSelectedBenefitPlan(null)
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>
            </div>

            {selectedBenefitPlan ? status === 'loading' ? (
                <p>Loading...</p>
            ) : status === 'error' ? (
                <span>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={'valuelist'}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        ref={ref}
                    />
                </>) : <></>}
        </div >
    )
}

export default ValueListTable
